import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ConfigurationSettings } from '/models/configuration-settings';
import { SiteConfigurationSettings } from '/models/site-configuration-settings';

export type ConfigStore = {
  configurationSettings: ConfigurationSettings | null;
  setConfigurationSettings: (config: ConfigurationSettings) => void;
  clearConfigurationSettings: () => void;
};

export type SecureConfigStore = {
  siteConfigurationSettings: SiteConfigurationSettings | null;
  setSiteConfigurationSettings: (config: SiteConfigurationSettings) => void;
  clearSiteConfigurationSettings: () => void;
};

export const useConfigStore = create<ConfigStore>()(
  persist(
    (set) => ({
      configurationSettings: null,
      setConfigurationSettings: (configurationSettings) =>
        set({
          configurationSettings,
        }),
      clearConfigurationSettings: () =>
        set({
          configurationSettings: null,
        }),
    }),
    {
      name: 'config-storage',
    }
  )
);

export const useSecureConfigStore = create<SecureConfigStore>((set) => ({
  siteConfigurationSettings: null,
  setSiteConfigurationSettings: (siteConfigurationSettings) =>
    set({
      siteConfigurationSettings,
    }),
  clearSiteConfigurationSettings: () =>
    set({
      siteConfigurationSettings: null,
    }),
}));
